import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import QueryNotCompleteError from 'app/PelatihanMandiriPage/components/QueryNotCompleteError'
import { EmptyState, EmptyStateAction } from 'components/EmptyState'
import { useGetQuiz } from 'api/microlearning/useAPIMateri'
import QuizApp from '../partials/Quiz/QuizApp'
import QuizPagePlaceholder from '../partials/Quiz/QuizPagePlaceholder'

const Quiz = ({ isDesktop = false }) => {
  const { query, isReady: isRouterReady, back } = useRouter()
  const [isQueryNotComplete, setIsQueryNotComplete] = useState(false)
  const { isSuccess, isError, data } = useGetQuiz(
    query.modul as string,
    query.id as string
  )

  useEffect(() => {
    if (isRouterReady && !query.modul) {
      setIsQueryNotComplete(true)
    }
  }, [query, isRouterReady])

  if (isQueryNotComplete) {
    return <QueryNotCompleteError isDesktop={isDesktop} />
  }

  if (isError) {
    return (
      <EmptyState
        title="Data gagal dimuat"
        description="Ada kesalahan pada sistem. Silakan coba beberapa saat lagi."
        fullscreen={!isDesktop}
        className={isDesktop ? 'min-h-[320px]' : undefined}
      >
        <EmptyStateAction
          className={isDesktop ? 'mb-4 max-w-sm' : undefined}
          onClick={() => window.location.reload()}
        >
          Muat Ulang
        </EmptyStateAction>
      </EmptyState>
    )
  }

  if (isDesktop && isSuccess) {
    return (
      <>
        <div className="flex flex-row">
          {query.from && (
            <Icon as="i" className="mr-2" onClick={back}>
              arrow_back
            </Icon>
          )}
          <div>
            <Text className="pb-1">LATIHAN</Text>
            <Text className="pb-3" variant="heading-lg">
              {data.data.name}
            </Text>
          </div>
        </div>
        <div className="bg-white h-[80vh]">
          <QuizApp
            materialId={query.id as string}
            data={data.data}
            isDesktop={isDesktop}
          />
        </div>
      </>
    )
  }

  if (isSuccess) {
    return <QuizApp materialId={query.id as string} data={data.data} />
  }

  return <QuizPagePlaceholder />
}

export default Quiz
